// Centralized generation model definitions - Single source of truth (DRY)

import type { GenerationModel } from '../types';

/**
 * Available generation models
 */
export const GENERATION_MODELS: GenerationModel[] = [
  { value: 'krea2', label: 'Krea 2 Turbo' },
];

/**
 * Default generation model
 */
export const DEFAULT_GENERATION_MODEL = 'krea2';

/**
 * Get model by value
 */
export const getModelByValue = (value: string): GenerationModel | undefined => {
  return GENERATION_MODELS.find(m => m.value === value);
};

/**
 * Get model label by value
 */
export const getModelLabel = (value: string): string => {
  return getModelByValue(value)?.label || value;
};
